/* Vani Vrtti display-only currency switcher (see snippets/vv-currency.liquid).
   Rewrites the price text on browsing pages. Never touches the cart, the checkout button or any form,
   so checkout and Razorpay always receive the same INR cart. */
(function () {
  'use strict';

  var cfg = document.getElementById('vv-currency-config');
  if (!cfg) return;

  var CURRENCIES = [
    { code: 'INR', name: 'Indian Rupee', country: 'India' },
    { code: 'USD', name: 'US Dollar', country: 'United States' },
    { code: 'GBP', name: 'British Pound', country: 'United Kingdom' },
    { code: 'EUR', name: 'Euro', country: 'Europe' },
    { code: 'AED', name: 'UAE Dirham', country: 'United Arab Emirates' },
    { code: 'SGD', name: 'Singapore Dollar', country: 'Singapore' },
    { code: 'CAD', name: 'Canadian Dollar', country: 'Canada' },
    { code: 'AUD', name: 'Australian Dollar', country: 'Australia' },
    { code: 'JPY', name: 'Japanese Yen', country: 'Japan' }
  ];
  var KNOWN = {};
  CURRENCIES.forEach(function (c) { KNOWN[c.code] = c; });

  /* Only visitors outside India are ever switched automatically; India always starts in INR. */
  var COUNTRY_TO_CURRENCY = { US: 'USD', GB: 'GBP', AE: 'AED', SG: 'SGD', CA: 'CAD', AU: 'AUD', JP: 'JPY' };
  'AT BE HR CY EE FI FR DE GR IE IT LV LT LU MT NL PT SK SI ES'.split(' ').forEach(function (c) {
    COUNTRY_TO_CURRENCY[c] = 'EUR';
  });

  var CHOICE_KEY = 'vv_currency';
  var RATES_KEY = 'vv_currency_rates';
  var CHOICE_MS = 30 * 24 * 3600 * 1000;
  var RATES_FRESH_MS = 12 * 3600 * 1000;
  var RATES_MAX_MS = 7 * 24 * 3600 * 1000;

  /* Price elements that may be converted. Cart, cart drawer and anything marked data-vv-keep-inr never are. */
  var PRICE_SELECTOR = 'sale-price, compare-at-price, .product-sticky-bar__button-price, [data-vv-money]';
  var KEEP_INR_SELECTOR = 'cart-drawer, [id*="main-cart"], [id*="cart-drawer"], [data-vv-keep-inr], #vv-currency-panel, form[action$="/cart"], script, style, textarea, input, select';
  var MONEY = /(Rs\.?|₹|INR)\s*([\d,]+(?:\.\d+)?)/i;

  var country = (cfg.getAttribute('data-country') || '').toUpperCase();
  var ratesUrl = cfg.getAttribute('data-rates-url');
  var originals = typeof WeakMap === 'function' ? new WeakMap() : null;
  var formatters = {};

  var current = 'INR';
  var rates = null;
  var ratesPromise = null;
  var panel, backdrop, list, errorEl, openers, lastOpener;

  function store(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function read(key) { try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; } }

  function savedChoice() {
    var c = read(CHOICE_KEY);
    if (c && KNOWN[c.code] && c.at && Date.now() - c.at < CHOICE_MS) return c.code;
    return null;
  }

  function startingCurrency() {
    var saved = savedChoice();
    if (saved) return saved;
    if (country && country !== 'IN' && COUNTRY_TO_CURRENCY[country]) return COUNTRY_TO_CURRENCY[country];
    return 'INR';
  }

  function storedRates() {
    var r = read(RATES_KEY);
    return r && r.rates && r.at ? r : null;
  }

  function loadRates() {
    if (rates) return Promise.resolve(rates);
    if (ratesPromise) return ratesPromise;
    var saved = storedRates();
    if (saved && Date.now() - saved.at < RATES_FRESH_MS) {
      rates = saved.rates;
      return Promise.resolve(rates);
    }
    ratesPromise = fetch(ratesUrl, { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error('rates ' + res.status); return res.json(); })
      .then(function (data) {
        var r = data && data.rates;
        if (!r || !r.USD) throw new Error('rates payload');
        var out = {};
        CURRENCIES.forEach(function (c) { if (c.code !== 'INR' && r[c.code] > 0) out[c.code] = Number(r[c.code]); });
        if (!out.AED && out.USD) out.AED = out.USD * 3.6725; /* AED is pegged to USD */
        rates = out;
        store(RATES_KEY, { rates: out, at: Date.now() });
        return rates;
      })
      .catch(function () {
        if (saved && Date.now() - saved.at < RATES_MAX_MS) { rates = saved.rates; return rates; }
        return null;
      })
      .then(function (r) { ratesPromise = null; return r; });
    return ratesPromise;
  }

  function effective() {
    return current !== 'INR' && rates && rates[current] ? current : 'INR';
  }

  function format(code, amountInr) {
    var f = formatters[code];
    if (!f) {
      try { f = new Intl.NumberFormat('en-US', { style: 'currency', currency: code, maximumFractionDigits: 0, minimumFractionDigits: 0 }); }
      catch (e) { f = { format: function (n) { return code + ' ' + n; } }; }
      formatters[code] = f;
    }
    return '≈ ' + f.format(Math.round(amountInr * rates[code]));
  }

  var lastOut = new WeakMap();

  function convertElement(el, code) {
    if (el.closest(KEEP_INR_SELECTOR)) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      /* If the theme wrote fresh INR text into a node we already converted (e.g. a variant change), take the new text as the source. */
      if (originals && originals.has(node) && lastOut.get(node) !== node.nodeValue) originals.delete(node);
      var source = originals && originals.has(node) ? originals.get(node) : node.nodeValue;
      var m = MONEY.exec(source);
      if (!m) continue;
      if (originals && !originals.has(node)) originals.set(node, source);
      /* A replacer function is required: "$" in the converted text would otherwise be read as a pattern. */
      var converted = code === 'INR' ? null : format(code, parseFloat(m[2].replace(/,/g, '')));
      var target = converted === null ? source : source.replace(MONEY, function () { return converted; });
      if (node.nodeValue !== target) node.nodeValue = target;
      lastOut.set(node, target);
    }
  }

  function updateCartNotes(code) {
    document.querySelectorAll('[data-vv-cart-note]').forEach(function (note) {
      var ref = note.querySelector('[data-vv-cart-ref]');
      if (ref) {
        var inr = parseFloat(ref.getAttribute('data-inr'));
        var text = code !== 'INR' && inr > 0 ? ' About ' + format(code, inr).replace('≈ ', '') + ' for reference.' : '';
        if (ref.textContent !== text) ref.textContent = text;
      }
    });
  }

  function render() {
    var code = effective();
    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) { convertElement(el, code); });
    updateCartNotes(code);
    document.querySelectorAll('[data-vv-cur-label]').forEach(function (l) { if (l.textContent !== code) l.textContent = code; });
    openers.forEach(function (o) { o.setAttribute('aria-label', 'Choose currency. Currently ' + code); });
    document.documentElement.setAttribute('data-vv-currency', code);
    if (list) {
      list.querySelectorAll('button').forEach(function (b) {
        var on = b.getAttribute('data-code') === code;
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
  }

  var burst = [];
  var observer = null;

  /* Convert only what was just added or changed, so the cost follows the size of the change, not of the page. */
  function convertWithin(root, code) {
    if (root.nodeType !== 1) return;
    if (root.matches(PRICE_SELECTOR)) convertElement(root, code);
    root.querySelectorAll(PRICE_SELECTOR).forEach(function (el) { convertElement(el, code); });
    if (root.matches('[data-vv-cart-note]') || root.querySelector('[data-vv-cart-note]')) updateCartNotes(code);
  }

  function onMutations(mutations) {
    var code = effective();
    if (code === 'INR') return;
    /* Safety stop: if something else keeps rewriting the same prices (e.g. another currency app), give up
       instead of ping-ponging with it. The page then simply stays as that other script leaves it. */
    var now = Date.now();
    burst = burst.filter(function (t) { return now - t < 1000; });
    burst.push(now);
    if (burst.length > 60) { if (observer) observer.disconnect(); return; }

    mutations.forEach(function (m) {
      if (m.type === 'characterData') {
        var host = m.target.parentElement && m.target.parentElement.closest(PRICE_SELECTOR);
        if (host) convertElement(host, code);
        return;
      }
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) convertWithin(n, code);
        else if (n.nodeType === 3 && n.parentElement) {
          var host = n.parentElement.closest(PRICE_SELECTOR);
          if (host) convertElement(host, code);
        }
      });
    });
  }

  function buildList() {
    CURRENCIES.forEach(function (c) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-code', c.code);
      b.setAttribute('aria-label', c.code + ', ' + c.name + ', ' + c.country);
      b.title = c.name + ' · ' + c.country;
      var flag = document.createElement('img');
      flag.className = 'vv-cur-list__flag';
      flag.alt = '';
      flag.width = 24;
      flag.height = 18;
      flag.loading = 'lazy'; /* never fetched until the hidden panel is opened */
      flag.src = cfg.getAttribute('data-flag-' + c.code.toLowerCase()) || '';
      var code = document.createElement('span');
      code.className = 'vv-cur-list__code';
      code.textContent = c.code;
      b.appendChild(flag);
      b.appendChild(code);
      li.appendChild(b);
      list.appendChild(li);
    });
  }

  function openPanel(opener) {
    lastOpener = opener;
    if (window.innerWidth >= 700) {
      var r = opener.getBoundingClientRect();
      panel.style.insetBlockStart = Math.round(r.bottom + 10) + 'px';
      panel.style.insetInlineEnd = Math.max(8, Math.round(window.innerWidth - r.right - 8)) + 'px';
    } else {
      panel.style.insetBlockStart = '';
      panel.style.insetInlineEnd = '';
    }
    panel.hidden = false;
    backdrop.hidden = false;
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    errorEl.hidden = true;
    loadRates().then(function (r) {
      if (!r) errorEl.hidden = false;
      render();
    });
    var active = list.querySelector('[aria-current="true"]') || list.querySelector('button');
    if (active) active.focus();
  }

  function closePanel(returnFocus) {
    panel.hidden = true;
    backdrop.hidden = true;
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    if (returnFocus && lastOpener) lastOpener.focus();
  }

  function choose(code) {
    current = code;
    store(CHOICE_KEY, { code: code, at: Date.now() });
    loadRates().then(function (r) {
      if (!r && code !== 'INR') errorEl.hidden = false;
      render();
      closePanel(true);
    });
  }

  function init() {
    panel = document.getElementById('vv-currency-panel');
    backdrop = document.querySelector('[data-vv-cur-backdrop]');
    list = panel && panel.querySelector('[data-vv-cur-list]');
    errorEl = panel && panel.querySelector('[data-vv-cur-error]');
    openers = Array.prototype.slice.call(document.querySelectorAll('[data-vv-cur-open]'));
    if (!panel || !list || !openers.length) return;

    buildList();
    openers.forEach(function (o) {
      o.hidden = false;
      o.addEventListener('click', function () { panel.hidden ? openPanel(o) : closePanel(true); });
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-code]');
      if (b) choose(b.getAttribute('data-code'));
    });
    panel.querySelector('[data-vv-cur-close]').addEventListener('click', function () { closePanel(true); });
    backdrop.addEventListener('click', function () { closePanel(false); });
    document.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') { closePanel(true); return; }
      if (e.key === 'Tab') {
        var f = panel.querySelectorAll('button');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* Re-run whenever prices are re-rendered (variant change, filters, quick view, cart updates). */
    observer = new MutationObserver(onMutations);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    current = startingCurrency();
    if (current !== 'INR') {
      loadRates().then(render);
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
